import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Button } from 'src/components/Buttons/Button';
import { IReport } from 'src/models/report';
import { IAppState } from 'src/models/state';
import { IAsyncState } from 'src/state/action';
import { changeTitle, closeModal, openModal, removeMessage, saveReport } from 'src/state/report/actions';
import { ReportSaveModal } from './ReportSaveModal';

// #region -------------- Interfaces -------------------------------------------------------------------

interface IStateProps {
  reportTitle: string;
  reportData: IReport;
  savedReportStatus: IAsyncState<IReport>;
  isOpen: boolean;
}

interface IDispatchProps {
  onReportSave: () => void;
  onRemoveMessage: () => void;
  onOpen: () => void;
  onClose: () => void;
  onTitleChange: (title: string) => void;
}

interface IOwnProps { }

interface IProps extends IStateProps, IDispatchProps, IOwnProps { }

// #endregion

// #region -------------- Component -------------------------------------------------------------------

class ReportSaveButton extends React.PureComponent<IProps> {

  private successMessageTimeout = null;

  public render() {
    return (
      <Fragment>
        <div className='rb-btn-container'>
          {this.renderButton()}
          {this.renderModal()}
        </div>

        {this.renderSuccessMessage()}
      </Fragment>
    );
  }

  // #region -------------- Button -------------------------------------------------------------------

  private renderButton = () => {
    const { reportData } = this.props;

    return (
      <Button
        title={reportData ? 'Update report' : 'Save report'}
        styleClasses='rb-btn-medium rb-btn-crimson'
        onClick={this.onOpen}
      />
    );
  }

  private onOpen = () => {
    clearTimeout(this.successMessageTimeout);

    this.props.onOpen();
  }

  // #endregion

  // #region -------------- Modal -------------------------------------------------------------------

  private renderModal = () => {
    const { reportData, reportTitle, savedReportStatus, isOpen } = this.props;

    return (
      <ReportSaveModal
        title={reportTitle}
        report={reportData}
        status={savedReportStatus}
        isOpen={isOpen}
        onCloseCallback={this.onClose}
        onChangeCallback={this.onTitleChange}
        onSaveCallback={this.onReportSave}
      />
    );
  }

  private onClose = () => {
    this.props.onClose();
  }

  private onTitleChange = (title: string) => {
    this.props.onTitleChange(title);
  }

  private onReportSave = () => {
    const { onReportSave, onRemoveMessage } = this.props;

    clearTimeout(this.successMessageTimeout);
    onReportSave();

    this.successMessageTimeout = setTimeout(() => {
      onRemoveMessage();
    }, 3000);
  }

  // #endregion

  // #region -------------- Success message -------------------------------------------------------------------

  private renderSuccessMessage = () => {
    const { savedReportStatus } = this.props;

    if (!savedReportStatus || !savedReportStatus.data || savedReportStatus.error) {
      return null;
    }

    return <div className='alert alert-success'>'Report has been successfully saved'</div>;
  }

  // #endregion
}

// #endregion

// #region -------------- Connect -------------------------------------------------------------------

const connected = connect<IStateProps, IDispatchProps, IOwnProps, IAppState>(
  (state) => {
    const { report: reportState } = state;
    const { report, reportTitle, savedReportStatus } = reportState;
    const reportData = report && report.data;
    const isOpen = reportState && reportState.isModalOpen;

    return {
      reportTitle,
      savedReportStatus,
      reportData,
      isOpen,
    };
  },
  (dispatch) => {
    return {
      onReportSave: () => dispatch(saveReport()),
      onRemoveMessage: () => dispatch(removeMessage()),
      onOpen: () => dispatch(openModal()),
      onClose: () => dispatch(closeModal()),
      onTitleChange: (title: string) => dispatch(changeTitle(title)),
    };
  },
)(ReportSaveButton);

export { connected as ReportSaveButton };

// #endregion
